// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eGgIK","name":"Header_name__3DtXP","birthday":"Header_birthday__39U1l","skeleton":"Header_skeleton__1NeN_"};